import styled from 'styled-components';

import colors from '../../../../styles/colors';

const AttachmentErrorWrapper = styled.div`
  width: 100%;
  background-color: ${colors.base.alpha};
  padding: 5px 10px;
  margin: 5px 0;
  border-radius: 5px;
`;

export {
  AttachmentErrorWrapper,
};
